import gridBgUrl from '@/layers/background-layer/assets/bg.png';
import { useStageCropStore } from '../../models/crop-stage-state';

const CropBg = () => {
    const { currentCropStageScale, operateBaseInfo } = useStageCropStore()((state) => state);
    const gridSize = 32 * currentCropStageScale;

    return (
        <div
            style={{
                width: operateBaseInfo.width,
                height: operateBaseInfo.height,
                transform: `translate(${operateBaseInfo.translateX}px, ${operateBaseInfo.translateY}px)`,
                backgroundImage: `url(${gridBgUrl})`,
                backgroundPosition: `${-operateBaseInfo.translateX}px ${-operateBaseInfo.translateY}px`,
                backgroundRepeat: 'repeat',
                backgroundSize: `${gridSize}px ${gridSize}px`,
            }}
            className="point-event-none"
        ></div>
    );
};

export default CropBg;
